import { render, staticRenderFns } from "./ApplicantStakeholderAddress.vue?vue&type=template&id=b8313d2c&"
import script from "./ApplicantStakeholderAddress.vue?vue&type=script&lang=js&"
export * from "./ApplicantStakeholderAddress.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantStakeholderAddress.vue?vue&type=style&index=0&id=b8313d2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports